import * as React from 'react';

export default function LinkArrow(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="58.696"
      height="58.695"
      viewBox="0 0 58.696 58.695"
    >
      <defs>
        <filter
          id="link-arrow-a"
          x={16.683}
          y={16}
          width={25.174}
          height={32.347}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy={3} />
          <feGaussianBlur stdDeviation={3} result="blur" />
          <feFlood floodColor="#f5ff00" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="link-arrow-b"
          x={0}
          y={0}
          width={58.696}
          height={58.695}
          filterUnits="userSpaceOnUse"
        >
          <feOffset />
          <feGaussianBlur stdDeviation={4} result="blur-2" />
          <feFlood floodColor="#f5ff00" floodOpacity={0.749} />
          <feComposite operator="in" in2="blur-2" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g filter="url(#link-arrow-a)">
        <path
          data-name="Path 4116"
          d="m25.686 22 6.612 5.871a1.781 1.781 0 0 1 0 2.6l-6.612 5.871 3.14-6.273v-1.79Z"
          fill="#f5ff00"
          fillRule="evenodd"
        />
      </g>
      <g filter="url(#link-arrow-b)">
        <g data-name="Intersection 37" fill="none">
          <path d="M46.7 29.348A17.348 17.348 0 0 1 29.352 46.7a17.35 17.35 0 0 1 0-34.7A17.348 17.348 0 0 1 46.7 29.348Z" />
          <path
            d="M44.7 29.348c0-4.1-1.596-7.954-4.495-10.853A15.247 15.247 0 0 0 29.352 14c-4.1 0-7.954 1.596-10.853 4.495a15.247 15.247 0 0 0-4.495 10.853c0 4.1 1.597 7.953 4.495 10.852a15.247 15.247 0 0 0 10.853 4.495c4.1 0 7.954-1.596 10.853-4.495A15.247 15.247 0 0 0 44.7 29.348m2 0c0 9.58-7.767 17.347-17.348 17.347-9.58 0-17.348-7.766-17.348-17.347C12.004 19.767 19.771 12 29.352 12S46.7 19.767 46.7 29.348Z"
            fill="#f5ff00"
          />
        </g>
      </g>
    </svg>
  );
}
